import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-week",
  templateUrl: "./med-icon-view-week.component.html",
})
export class MedIconViewWeekComponent extends SvgMixinComponent {}
